/* eslint-disable */
import $ from 'jquery';
import slick from 'slick-carousel';
import BaseModule from './BaseModule';
import debounce from '../libs/Debounce';

export default class VehicleSlider extends BaseModule {
  constructor(el, factory) {
    super(el, factory, 'VehicleSlider');

    // initSrcImageVideo($(el)).then(() => {
      initSlides();
    // });

    function hasExtension(fileName, exts) {
      return (new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$')).test(fileName);
    }

    // Apply video src for desktop
    function initSrcImageVideo(slick) {
      return new Promise((resolve, reject) => {
        slick.find('.hero-slider__item').each(function (index, el) {
          const screens = ['desktop', 'mobile'];
          screens.forEach((screen, key) => {
            const path = $(el).attr(`data-src-${screen}`);
            if (hasExtension(path, ['.jpg', '.png'])) {
              applyTemplate(el, path, 'IMAGE', index, screens[1 - key]);
            } else if (hasExtension(path, ['.mp4'])) {
              applyTemplate(el, path, 'VIDEO', index, screens[1 - key]);
            }
          });
        });
        resolve();
      })
    }

    function applyTemplate(el, path, type, index, screen) {
      switch (type) {
        case 'IMAGE':
          $(el).addClass('image').prepend(`
          <div class="slide-image ${!index && 'show'} hide-${screen}" style="background-image:url('${path}');">
            <img src="${path}" class="image-entity" alt="" />
          </div>
          `);
          break;

        case 'VIDEO':
          $(el).addClass('video').prepend(`
          <video class="slide-video ${!index && 'show'} hide-${screen}" muted playsinline preload="metadata" >
            <source src="${path}" type="video/mp4" />
          </video>
          `);
          break;

        default:
          break;
      }
    }

    function initSlides() {
      const slideWrapper = $('.hero-slider');
      //if(slideWrapper.hasClass('slick-initialized')) return;

      const slideSubWrapper = $('.vehicle-sub');
      const transitionTime = Number($(el).attr('data-transition-time')) * 1000;
      const btnControl = $('.btn-hero-control');
      let lazyCounter = 0;
      let tick;
      let isPaused = false;
      let timeNow = 0;
      let percent = 0;
      let basePercent = 0;
      let video;
      let elapsed = 0;

      // Window active
      window.addEventListener('focus', function () {
        if (!slideWrapper.hasClass('paused') && slideWrapper.hasClass('blur')) {
          mainPlay();
          slideWrapper.removeClass('blur');
        }
      });

      // Window Inactive
      window.addEventListener('blur', function () {
        if (isPaused) {
          slideWrapper.addClass('paused');
        } else {
          slideWrapper.addClass('blur');
          mainPause();
        }
      });

      function mainPause() {
        isPaused = true;
      }

      function mainPlay() {
        isPaused = false;
        timeNow = Date.now();
      }

      // Set Hero height to keep same aspect ratio on screens from Large
      function setHeight() {
        let ratio = 56.25;
        let windowWidth = $(window).width();
        let windowHeight = $(window).height();
        let stickyNavHeight = 0;

        const cta = $('.sticky-cta');
        if (cta.length) {
          stickyNavHeight = cta.outerHeight();
        }

        let viewportHeight = windowHeight - stickyNavHeight;
        let calculatedHeroHeight = windowWidth * ratio / 100;

        if (calculatedHeroHeight > viewportHeight) {
          calculatedHeroHeight = viewportHeight;
        }

        if (windowWidth >= 1024) {
          $('.vehicle-slider, .vehicle-slider .slick-slide').height(Math.round(calculatedHeroHeight));
        }
      }
      // const setHeightOnResize = debounce(() => setHeight());

      // When the slide is changing
      function playPauseSlide(slick, control) {
        let currentSlide = slick.find('.slick-current .hero-slider__item');
        percent = 0;
        basePercent = 0;
        elapsed = 0;

        function progressLoopVideoProgress(video) {
          video.play();
          percent = Math.ceil((video.currentTime / video.duration) * 100);

          if (percent === 100) {
            pauseVideo(video);
            slideWrapper.slick('slickNext');
          }
        }

        function progressLoopImageProgress(duration) {
          elapsed = Date.now() - timeNow;
          percent = Math.ceil((elapsed / duration) * 100) + basePercent;

          if (percent === 100) {
            slideWrapper.slick('slickNext');
            basePercent = 0;
          }
        }

        function startImageProgress() {
          timeNow = Date.now();
          tick = setInterval(function () {
            progressLoopImageProgress(transitionTime);
          }, 16);
        }

        function playVideo(video) {
          video.play();
          tick = setInterval(function () {
            progressLoopVideoProgress(video);
          }, 16);
        }

        function pauseVideo(video) {
          video.pause();
          clearTimeout(tick);
          setTimeout(function () {
            video.currentTime = 0;
          }, 400)
        }
        currentSlide.children('.caption').addClass('show');
        const hideClass = $(window).width() >= 768 ? '.hide-mobile' : '.hide-desktop';
        if (currentSlide.hasClass('image')) {
          const image = currentSlide.children('.slide-image'+hideClass);
          if (image.length && control === 'play') {
            startImageProgress();
          }
        }
        if (currentSlide.hasClass('video')) {
          const video = currentSlide.children('.slide-video'+hideClass);
          if(video.length){
            const videoElement = currentSlide.children('video').get(0);
            if (videoElement != null) {
              if (control === 'play') {
                playVideo(videoElement);
              } else {
                pauseVideo(videoElement);
              }
            }
          }
        }
      }

      // Initialize
      slideWrapper.on('init', function (slick) {
        slick = $(slick.currentTarget);
        setTimeout(function () {
          // setHeight();
          // window.addEventListener('resize', setHeightOnResize);
          playPauseSlide(slick, 'play');
        }, 1000);
      });

      slideWrapper.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        const next = slick.$slides[nextSlide] ?? false;
        if(next){
          const isBlack = !!next.querySelector('.hero-slider__item').classList.contains('hero-text-black');
          const dots = slick.$dots.get(0);
          dots?.classList.toggle('text-black', isBlack);
        }
        slick = $(slick.$slider);
        playPauseSlide(slick, 'pause');
      });

      slideWrapper.on('afterChange', function (event, slick) {
        clearTimeout(tick);
        slick = $(slick.$slider);
        playPauseSlide(slick, 'play');
      });

      // Start the slider
      slideWrapper.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        infinite: true,
        lazyLoad: 'progressive',
        speed: 600,
        arrows: false,
        dots: true,
        asNavFor: slideSubWrapper,
        cssEase: 'cubic-bezier(0.87, 0.03, 0.41, 0.9)',
      });

      slideSubWrapper.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: slideWrapper,
        fade: true,
        arrows: false,
        dots: false,
        focusOnSelect: true,
        mobileFirst: true,
      });
    }
  }
}
